import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import {
  PHONE_NO_LENGTH,
  showFilterlist,
  SWAL_SETTINGS,
  URL_REGEX,
} from "../../../../utils/Constants";
import {
  DT,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as usersService from "../../services/customer.services";
import * as Yup from "yup";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";
import PhoneInput from "../../../../utils/PhoneInput";

const CustomerEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation();

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_edit_customer_details"), url: "/admin/customers/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    usersService
      .Details({ _id: params.id })
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response.data.image);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  const PHONE_REGEX = /^\+?\d{1,4}\s?\d{6,14}$/; // Handles formats like "+91 7894561230"
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(t("label_name_error"))
      .test(
        "no-spaces",
        t("label_name_error"),
        (value) => value && value.trim().length > 0,
      )
      .max(80, t("max_characters_error", { count: 80 })),

    phone_number: Yup.string()
      .required(t("label_phone_error"))
      .matches(PHONE_REGEX, t("label_phone_invalid"))
      .test(
        "no-spaces",
        t("label_phone_error"),
        (value) => value && value.trim().length > 0,
      ),

    email: Yup.string()
      .required(t("label_email_error"))
      .matches(EMAIL_REGEX, t("label_email_invalid"))
      .max(100, t("max_characters_error", { count: 100 })),

    address: Yup.string()
      .required(t("label_address_error"))
      .test(
        "no-spaces",
        t("label_address_error"),
        (value) => value && value.trim().length > 0,
      )
      .max(250, t("max_characters_error", { count: 250 })),
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={{
            name: showdefault && showdefault.name ? showdefault.name : "",
            phone_number:
              showdefault && showdefault.phone_number
                ? showdefault.phone_number
                : "",
            email: showdefault && showdefault.email ? showdefault.email : "",
            address:
              showdefault && showdefault.address ? showdefault.address : "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("_id", params.id);
            formData.append("name", values.name);
            formData.append("phone_number", values.phone_number);
            formData.append("email", values.email);
            formData.append("address", values.address);
            usersService
              .EditDetails(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  if (saveType !== "Save") {
                    setTimeout(() => {
                      navigate(`/admin/customers/list/${params.pgno}`);
                    }, 1000);
                  }
                  globalLoader(false);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                }
                globalLoader(false);
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">
                          {t("label_edit_customer_details")}
                        </h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="name" className="text-left d-flex">
                            {t("label_name")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="name"
                            id="name"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            className="form-control"
                            placeholder="Enter name"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.name && touched.name && errors.name}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="email" className="text-left d-flex">
                            {t("label_email")}:
                            <span className="requirestar">*</span>
                          </label>
                          <input
                            name="email"
                            type="text"
                            id="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            className="form-control"
                            placeholder={t("placeholder_email_address")}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.email && touched.email && t(errors.email)}
                          </span>
                        </div>

                        {/* <div className="col-md-12 text-center form-group">
                          <label htmlFor="phone_number" className="text-left d-flex">
                           {t("label_contact_no")}:<span className="requirestar">*</span>
                          </label>
                          <PhoneInput
                            name="phone_number"
                            type="text"
                            id="phone_number"
                            onChange={(e) => {
                              setFieldValue("phone_number", e?.phone_number);
                            }}
                            // onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone_number}
                            className="form-control"
                            placeholder={t("web_inquiry_form_placeholder_contact_number")}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.phone_number && touched.phone_number && DT(t(errors.phone_number), { PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max })}
                          </span>
                        </div> */}

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="phone_number"
                            className="text-left d-flex"
                          >
                            {t("label_contact_no")}:
                            <span className="requirestar">*</span>
                          </label>
                          <input
                            name="phone_number"
                            type="tel"
                            id="phone_number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone_number}
                            className="form-control"
                            placeholder={t(
                              "web_inquiry_form_placeholder_contact_number",
                            )}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.phone_number &&
                              touched.phone_number &&
                              DT(t(errors.phone_number), {
                                PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min,
                                PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max,
                              })}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("label_address")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="address"
                            id="address"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.address}
                            className="form-control"
                            placeholder="Enter address"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.address &&
                              touched.address &&
                              errors.address}
                          </span>
                        </div>

                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                      {/* // : "Loader"} */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default CustomerEdit;
